var React = require('react');

function Shovel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M500.28 96.39l-84.67-84.68a40 40 0 0 0-56.56 0l-32.67 32.67a98.91 98.91 0 0 0-18.77 114.77L197.35 269.4l45.26 45.23 110.25-110.24a98.88 98.88 0 0 0 114.75-18.76L500.28 153a40 40 0 0 0 0-56.57zm-77.91 44a35.89 35.89 0 0 1-50.75-50.75l15.7-15.7 50.75 50.75z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M287.87 405.13L220 473c-50 50-181 45.3-203.66 22.65S-11 342 39 292l67.85-67.88a32 32 0 0 1 45.25 0l135.77 135.76a32 32 0 0 1 0 45.25z","className":"fa-primary","key":2})]);
}

Shovel.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Shovel;

Shovel.default = Shovel;
